import { Button, DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierFuelSurchargeList extends Layout {
    buttonAddSurcharge: Button;
    layoutheaderTitle: LayoutHeader;
    sourceCustomerFuelOptions: DataSource;
    tableSurcharges: Table;
}
